import React from 'react'
import { AuthorizedRoute } from 'react-authorized'
import BasicLayout from '../Layouts/BasicLayout'
import NormalLayout from '../Layouts/NormalLayout'
import NotFound from '../containers/views/NotFound'
import { observer, inject } from 'mobx-react'
import { HashRouter } from 'react-router-dom'
import { authorizedRoutes, normalRoutes } from 'config/routes'

interface IP {
  loginStore?: ILoginStore.LoginStore
}
const JZAuthorizedRoute: any = AuthorizedRoute
@inject('loginStore')
@observer
class Router extends React.Component<IP, any> {
  render() {
    return (
      <HashRouter>
        <JZAuthorizedRoute
          authorities={this.props.loginStore.isLogin ? 'user' : ''}
          authorizedRoutes={authorizedRoutes}
          authorizedLayout={BasicLayout}
          normalRoutes={normalRoutes}
          normalLayout={NormalLayout}
          notFound={NotFound}
        />
      </HashRouter>
    )
  }
}

export default Router
